<template>
  <b-modal id="agreement-modal" size="md" title="Agreement details" hide-footer>
    <div v-if="!agreement" class="text-center p-4">
      <p>The vessel is not serviced under an agreement with a distributor. Payment is only possible via Stripe.</p>
  
      <b-button @click="$router.push('distributors')" size="sm" variant="info" block class="w-100">
        Choose a distributor
      </b-button>
    </div>
    <div v-else class="agreement-details">
      <div class="agreement-info">
        <div class="agreement-item">
          <i class="fas fa-signature fa-fw mr-2" />
          <span>
            <strong>Name:</strong>
            {{ agreement.name }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-file-contract fa-fw mr-2" />
          <span>
            <strong>Agreement ID:</strong>
            {{ agreement.displayId }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-money-bill-wave fa-fw mr-2" />
          <span>
            <strong>Currency:</strong>
            {{ agreement.currency }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-calendar-alt fa-fw mr-2" />
          <span :class="{ 'text-danger': isExpired }">
            <strong>Valid till:</strong>
            {{ formatDate(agreement.validTill) }}
          </span>
        </div>
  
        <hr class="w-100 my-2">
        <h6 class="mb-2">
          Available Services
        </h6>
  
        <div class="agreement-item">
          <i class="fas fa-check-circle fa-fw text-success mr-2" />
          <span>
            <strong>Primar ENC:</strong>
            valid till: {{ formatDate(agreement.validTill) }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-times-circle fa-fw text-danger mr-2" />
          <span>
            <strong>UKHO AVCS:</strong>
            &nbsp;
            <a href="#">request the service...</a>
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-times-circle fa-fw text-danger mr-2" />
          <span>
            <strong>UKHO ADP/eNP:</strong>
            valid till: {{ formatDate(agreement.validTill) }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-check-circle fa-fw text-success mr-2" />
          <span>
            <strong>NAVAREA:</strong>
            &nbsp;
            <a href="#">request the service...</a>
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-times-circle fa-fw text-danger mr-2" />
          <span>
            <strong>AIO:</strong>
            &nbsp;
            <a href="#">request the service...</a>
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-check-circle fa-fw text-success mr-2" />
          <span>
            <strong>Monitoring:</strong>
            valid till: {{ formatDate(agreement.validTill) }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-check-circle fa-fw text-success mr-2" />
          <span>
            <strong>Tides:</strong>
            valid till: {{ formatDate(agreement.validTill) }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-check-circle fa-fw text-success mr-2" />
          <span>
            <strong>Weather:</strong>
            valid till: {{ formatDate(agreement.validTill) }}
          </span>
        </div>
        <div class="agreement-item">
          <i class="fas fa-check-circle fa-fw text-success mr-2" />
          <span>
            <strong>Route planning:</strong>
            valid till: {{ formatDate(agreement.validTill) }}
          </span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    agreement: {
      type: Object,
      default: null,
    },
  },
  computed: {
    // Проверка, истек ли срок действия договора
    isExpired() {
      if (!this.agreement || !this.agreement.validTill) return false
      return new Date(this.agreement.validTill) < new Date()
    },
  },
  methods: {
    // Форматирование даты в удобочитаемый формат
    formatDate(dateString) {
      if (!dateString) return 'N/A'
      return new Date(dateString).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },
  },
}
</script>

<style scoped>
.agreement-details {
  padding: 0.5rem;
}

.agreement-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.agreement-item {
  display: flex;
  align-items: center;
}
</style>
